var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"paas-table-expand"},[_c('Table',{attrs:{"slot":"table","stripe":"","border":"","data":_vm.rowData.orderProductList,"columns":_vm.tableColumns,"no-data-text":_vm.noDataText},slot:"table"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }